import ScheduleCompletedCoursesModal from './ScheduleCompletedCoursesModal'
import useModal from '../../../../lib/hooks/useModal'
import useSchedulerLogin from '../../../../lib/hooks/useSchedulerLogin'
import { CompletedCoursesData } from '../../../../types'
import {
  CompletedCoursePreference,
  useUpsertCompletedCoursePreferenceMutation
} from '../../../../generated/graphql'
import useNotification from '../../../../lib/hooks/useNotification'

type ScheduleCompletedCoursesModalWrapperProps = {
  /** Contains information about the active term(s) and completed items */
  completedCoursesData: Array<CompletedCoursesData>
  /** Indicates if the modal is open */
  isOpen: boolean
  /** Owner AppUserId. Used by Student Overview Plans */
  ownerAppUserId: number
}

const ScheduleCompletedCoursesModalWrapper = ({
  completedCoursesData,
  isOpen,
  ownerAppUserId
}: ScheduleCompletedCoursesModalWrapperProps) => {
  const { hideModal } = useModal()
  const { showErrorNotif } = useNotification()

  // The selectedTermCode is used by scheduler to auto-select the term for the student; if there is more than one, then pass undefined so scheduler will prompt the student
  const selectedTermCode =
    completedCoursesData.length === 1 ? completedCoursesData[0].termCode : undefined
  const { doSchedulerLogin } = useSchedulerLogin(ownerAppUserId, selectedTermCode)

  const [upsertCompletedCoursePreference] = useUpsertCompletedCoursePreferenceMutation({
    onCompleted: () => {
      doSchedulerLogin()
      hideModal()
    },
    onError: () => showErrorNotif('An error occurred. Please refresh page.')
  })

  const handleCancel = () => {
    hideModal()
  }

  const handleSubmit = (completedCourses: CompletedCoursePreference[]) => {
    upsertCompletedCoursePreference({
      variables: {
        input: {
          appUserId: ownerAppUserId,
          completedCoursePreferences: completedCourses
        }
      }
    })
  }

  return (
    <ScheduleCompletedCoursesModal
      completedCoursesData={completedCoursesData}
      isOpen={isOpen}
      onCancel={handleCancel}
      onSubmit={handleSubmit}
    />
  )
}

export default ScheduleCompletedCoursesModalWrapper
